import { render } from "./upload-img.vue?vue&type=template&id=121be7dc&scoped=true"
import script from "./upload-img.vue?vue&type=script&lang=js"
export * from "./upload-img.vue?vue&type=script&lang=js"

import "./upload-img.vue?vue&type=style&index=0&id=121be7dc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121be7dc"]])

export default __exports__